import * as preact from "preact";
import { Component, Fragment, createRef, h } from "preact";
import { route } from "preact-router";
import { withText, Text, MarkupText } from "preact-i18n";
import * as TextMask from "vanilla-text-mask";
import classnames from "classnames";

import { Transaction, Card, TransactionVerify, PaymentIntent } from "../models";
import { makeSureTransactionWasVerified, Shared } from "../utils";
import PayButtonComponent from "./pay-button.component";
import {
    Observable,
    Subscription,
    from,
    concat,
    Subject,
    of,
    BehaviorSubject
} from "rxjs";
import {
    distinctUntilChanged,
    debounceTime,
    switchMap,
    tap,
    catchError
} from "rxjs/operators";
import { Config } from "../app.configs";
import { TransactionService } from "../services/transaction.service";
import { GeoService } from "../services/geo.service";
import RedirectModal from "../services/redirect-modal.service";
import CardComponent from "./shared/card.component";
import {
    setupPostForm,
    removeHTMLElement,
    autoCompleteKey
} from "../utils/dom";
import { TranasctionErrorComponent } from "./shared/transaction-error.component";
import SelectComponent from "./select.component";
import { validateEmail } from "../utils";

interface State {
    transaction?: Transaction;
    loading: boolean;
    formValid: boolean;
    cardNumberValid: boolean;
    expDateValid: boolean;
    cardCvvValid: boolean;
    error_code: string;
    card: Card;
    error?: string;
    customer: any;
    defaultCustomer: any;
    changeBillingEmail: boolean;
    askCustomerInformation: boolean;
}

@withText({
  
    firstname_label: 'customer.firstname',
    firstname_placeholder: 'customer.firstname_placeholder',
    lastname_label: 'customer.lastname',
    lastname_placeholder: 'customer.lastname_placeholder',
    email_label: 'customer.email',
    email_placeholder: 'customer.email_placeholder',
})

export default class GimUemoaComponent extends Component<any, State> {
    state: State = {
        loading: false,
        formValid: false,
        cardNumberValid: true,
        expDateValid: true,
        cardCvvValid: true,
        card: null,
        error_code: "",
        customer: {
            firstname: null,
            lastname: null,
            email: null
        },
        defaultCustomer: {
            firstname: null,
            lastname: null,
            email: null
        },
        changeBillingEmail: false,
        askCustomerInformation: true
    };
    transactionService = new TransactionService();
    token: string = "";
    intent: PaymentIntent;
    card: Card;
    cardHandler: any;
    cardErrors: any = {};
    cardValidation: any = null;
    form: HTMLFormElement;

    subscription: Subscription;
    verifyTransaction: TransactionVerify;

    constructor(props) {
        super();
    }

    componentWillUnmount() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    componentDidMount() {
        this.subscription = makeSureTransactionWasVerified(verifyTrans => {
            this.token = Shared.token;
            const transaction = verifyTrans.transaction;
            const askCustomerInformation = verifyTrans.getAskCustomerInformationSettting();

            this.setState({ transaction, askCustomerInformation });

            this.filldefaultValues(transaction);
        });
    }

    filldefaultValues(transaction) {
        let defaultCustomer = {};
        if (transaction.customer) {
            if (transaction.customer.firstname != "Unknown") {
                defaultCustomer["firstname"] = transaction.customer.firstname;
            }

            if (transaction.customer.firstname != "Unknown") {
                defaultCustomer["lastname"] = transaction.customer.lastname;
            }

            if (transaction.customer.email) {
                defaultCustomer["email"] = transaction.customer.email;
            }
        }

        this.setState({ customer: { ...defaultCustomer }, defaultCustomer });
    }

    renderCustomerNameFields(trans: any) {
        if (this.state.askCustomerInformation === false) {
            return <Fragment></Fragment>;
        }

        if (
            this.state.defaultCustomer.lastname &&
            this.state.defaultCustomer.firstname
        ) {
            return <Fragment></Fragment>;
        }

        // If customer has no default lastname and firstname, then aske for it
        return (
            <div class="row">
                <div class="col-md-6 pr-3 pr-md-1">
                    <div class="form-group form-group-with-label">
                        <label for="lastname">{trans.lastname_label}</label>
                        <input
                            id="lastname"
                            type="text"
                            autoComplete={autoCompleteKey("lastname")}
                            name={autoCompleteKey("lastname")}
                            value={this.state.customer.lastname}
                            required={true}
                            class={classnames("form-control", {
                                "is-invalid": !this.customerIsValid("lastname")
                            })}
                            placeholder={trans.lastname_placeholder}
                            onInput={e =>
                                this.updateCustomerInformation(e, "lastname")
                            }
                        />
                    </div>
                </div>
                <div class="col-md-6 pl-3 pl-md-1">
                    <div class="form-group form-group-with-label">
                        <label for="firstname">{trans.firstname_label}</label>
                        <input
                            id="firstname"
                            type="text"
                            autoComplete={autoCompleteKey("firstname")}
                            name={autoCompleteKey("firstname")}
                            value={this.state.customer.firstname}
                            required={true}
                            class={classnames("form-control", {
                                "is-invalid": !this.customerIsValid("firstname")
                            })}
                            placeholder={trans.firstname_placeholder}
                            onInput={e =>
                                this.updateCustomerInformation(e, "firstname")
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderCustomerEmailField(trans: any) {
        if (!this.state.askCustomerInformation) {
            return <Fragment></Fragment>;
        }

        if (
            !validateEmail(this.state.defaultCustomer.email) ||
            this.state.changeBillingEmail
        ) {
            return this.renderEditCustomerEmailField(trans);
        } else {
            return this.renderShowCustomerEmail();
        }
    }

    renderEditCustomerEmailField(trans: any) {
        return (
            <div class="form-group form-group-with-label">
                <label for="email">
                    {trans.email_label}{" "}
                    <span class="small text-muted">
                        (<Text id="customer.email_description" />)
                    </span>
                </label>
                <input
                    type="text"
                    id="email"
                    autoComplete={autoCompleteKey("email")}
                    name={autoCompleteKey("email")}
                    required={true}
                    value={this.state.customer.email}
                    class={classnames("form-control", {
                        "is-invalid": !this.customerIsValid("email")
                    })}
                    placeholder={trans.email_placeholder}
                    onInput={e => this.updateCustomerInformation(e, "email")}
                />
            </div>
        );
    }

    renderShowCustomerEmail() {
        return (
            <label for="email">
                <span class="small text-muted">
                    <MarkupText
                        id="customer.receipt_to"
                        fields={{ email: this.state.customer.email }}
                    />
                </span>
                <br />
                <a
                    role="button"
                    class="btn-link small"
                    onClick={() => this.setState({ changeBillingEmail: true })}
                >
                    <Text id="customer.change_email" />
                </a>
            </label>
        );
    }

    updateCustomerInformation(e, key) {
        const customer = this.state.customer;
        customer[key] = e.target.value;
        this.setState({ customer: { ...customer } }, () => {
            this.checkFormValidity();
        });
    }

    checkFormValidity() {
        let formValid = true;

        if (this.state.askCustomerInformation === false) {
            this.setState({ formValid });
            return;
        }

        if (Object.keys(this.state.customer).length === 0) {
            formValid = false;
        }

        for (const key in this.state.customer) {
            if (!this.customerIsValid(key)) {
                formValid = false;
            }
        }

        this.setState({ formValid });
    }

    customerIsValid(key) {
        const defaultCheck =
            typeof this.state.customer[key] === "string" &&
            this.state.customer[key].trim() !== "";

        if (key === "email") {
            // Validate email
            return defaultCheck && validateEmail(this.state.customer[key]);
        } else {
            return defaultCheck;
        }
    }

    submitForm() {
        this.form?.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
        );
    }

    openDialog(id: string, url: string) {
        RedirectModal.create(`fexm-${id}`, `fexf-${id}`, url);
        RedirectModal.open(`fexm-${id}`, () => {
            this.checkStatus(this.token, this.intent.reference);
        });
    }

    handleSubmit = (e: any) => {
        console.log("1");
        e.preventDefault();

        if (!this.state.formValid) {
            return;
        }

        this.setState({ loading: true });

        // Base on card response
        this.transactionService.createPayment(
            'gim_uemoa_card', this.token,
            {
                pan: this.state.card.number, cvv: this.state.card.cvv,
                expiration_date: this.state.card.toGimExpDate()
            }

        ).then((intent: PaymentIntent) => {
            Shared.intent = intent; // Update intent
            this.intent = intent;
            console.log(this.intent);
            if (this.intent.status === 'pending' && this.intent.metadata.three_ds_url) {
                console.log('Inside three ds');
                this.openDialog(intent.reference,this.intent.metadata.three_ds_url);
                this.setState({ loading: false });
            } else {

                console.log('Inside thrs');
                console.log(this.intent);
                this.checkStatus(this.token, intent.reference);
            }
        }).catch(({ message }) => {
            console.log(message);
            this.setState({ error: message, error_code: null, loading: false });
        });
    };

    // Ajoutez cette méthode pour recevoir la carte depuis CardComponent
    updateCard(card: Card | null) {
        // Mettez à jour l'état avec l'objet card reçu
        this.setState({ card }, () => {
            // Vous pouvez ici vérifier si le formulaire est valide
            this.checkFormValidity();
        });
    }

    render(trans) {
        return (
            <form
                id="card"
                class="payment-container d-flex flex-column h-100"
                onSubmit={this.handleSubmit}
                autoComplete="off"
                ref={ref => {
                    this.form = ref;
                }}
            >
                <div class="modal-body mb-auto">
                    <div class="form-group">
                        {this.renderCustomerNameFields(trans)}
                        {this.renderCustomerEmailField(trans)}

                        {/* Intégration du CardComponent */}
                        <CardComponent
                            onChanged={card => this.updateCard(card)}
                        />
                    </div>

                    <TranasctionErrorComponent
                        error={this.state.error}
                        error_code={this.state.error_code}
                    />
                </div>

                <div class="modal-footer">
                    <PayButtonComponent
                        loading={this.state.loading}
                        disabled={!this.state.formValid}
                    />
                </div>
            </form>
        );
    }

    private checkStatus(token: string, payment_intent_reference: string) {
        this.transactionService
            .paymentStatus("gim_uemoa_card", token, payment_intent_reference)
            .then((intent: PaymentIntent) => {
                Shared.intent = intent;
                if (intent.status === "approved") {
                    route("/status/success", true);
                } else {
                    // Show form again
                    this.setState({
                        error: "Transaction échouée. Veuillez reessayer",
                        error_code: intent.last_error_code,
                        loading: false
                    });
                }
            });
    }
}
